import { CheckCircleTwoTone, CloseCircleTwoTone, ExclamationCircleTwoTone } from '@ant-design/icons';
import type { ArrayElement } from '@evidia/shared';
import { ExamResult } from '@evidia/shared';
import { Tooltip } from 'antd';
import type { PresetColorType } from 'antd/es/_util/colors';
import type { LiteralUnion } from 'antd/lib/_util/type';
import { EXAM_RESULT_TEXT } from '../const/const';
import type { RouterOutput } from '../utils/trcp';
import StyledTag from './Styled/Tag';

const COLOR_MAP: Record<
	ExamResult,
	LiteralUnion<PresetColorType | 'success' | 'processing' | 'error' | 'default' | 'warning'>
> = {
	[ExamResult.SUCCESS]: 'green',
	[ExamResult.FAIL]: 'red',
	[ExamResult.DID_NOT_TAKE_PLACE]: 'default',
};

const SHORT_ICONS_MAP: Record<ExamResult, AnyReactElement> = {
	[ExamResult.SUCCESS]: <CheckCircleTwoTone twoToneColor="#52C41A" />,
	[ExamResult.FAIL]: <CloseCircleTwoTone twoToneColor="#F5222D" />,
	[ExamResult.DID_NOT_TAKE_PLACE]: <ExclamationCircleTwoTone twoToneColor="#959595" />,
};

const TT_MAP: Record<ExamResult, string> = {
	[ExamResult.SUCCESS]: 'Úspěch',
	[ExamResult.FAIL]: 'Neúspěch',
	[ExamResult.DID_NOT_TAKE_PLACE]: 'Nekonalo se',
};
type ExamResultPrismaType = NonNullable<
	ArrayElement<ArrayElement<RouterOutput['student']['studentsWithExams']>['studentOnExam']>['result']
>;

interface Props {
	type: ExamResult | ExamResultPrismaType;
	tag?: boolean;
	short?: boolean;
}

const ExamResultType: React.FC<Props> = ({ type, tag = true, short = false }) => {
	if (short) {
		return <Tooltip title={TT_MAP[type]}>{SHORT_ICONS_MAP[type]}</Tooltip>;
	}

	if (tag) {
		return (
			<Tooltip title={TT_MAP[type]}>
				<StyledTag color={COLOR_MAP[type]}>{EXAM_RESULT_TEXT[type]}</StyledTag>
			</Tooltip>
		);
	}

	return <>{EXAM_RESULT_TEXT[type]}</>;
};

export default ExamResultType;
